export const toastCopyEs = {
    saved: "Guardado",
    savedForNow: "Guardado por el momento.",
    savedSuccessfully: "Guardado correctamente",
    errorSaving: "Error al guardar",
    errorSavingTracker: "Error al guardar el seguimiento",
    updateFailed: "No se ha podido actualizar",
    errorUpdating: "Error al actualizar",
    errorCreating: "Error al crear",
    errorCreatingInput: "Error al crear el campo",
    errorCreatingDiaryLog: "Error al crear el registro del diario",
    errorCreatingEvent: "Error al crear el evento",
    errorUpdatingEvent: "Error al actualizar el evento",
    errorUpdatingProfile: "Error al actualizar el perfil, vuelva a intentarlo",
    errorWhileUploading: "Error al enviar",
    refreshAndRetry: "Error, actualice la página y vuelva a intentarlo",
    noDataReturned: "No se han devuelto datos",
    settingsSaved: "Ajustes guardados",
    copiedToClipboard: "Copiado al portapapeles",
    linkCopiedToClipboard: "Enlace copiado al portapapeles",
    pleaseSelectFile: "Seleccione un archivo",
    pasteImageFromClipboard: "Pegue una imagen del portapapeles (Ctrl+V o Cmd+V)",
    loggedOutSuccess: "Sesión cerrada correctamente",
    loggingIn: "Iniciando sesión",
    errorLoggingIn: "Error de acceso",
    loginSuccessful: "Acceso correcto",
    signUpSuccessful: "Registro correcto",
    transferRequested:
        "Transferencia solicitada - compruebe su correo electrónico para asegurarse de que se ha completado.",
    organisationAdded: "Organización añadida",
    organisationAlreadyAdded: "Organización ya añadida",
    deletionRequestSent: "Solicitud de eliminación enviada",
    userAuthenticated: "Usuario autenticado",
    codeIncorrect: "Código incorrecto",
    codeCorrect: "Código correcto",
    errorSigningIn: "Error de acceso",
    otpFailedToSend: "No se ha podido enviar la contraseña de un solo uso",
    passwordUpdatedSuccess: "Contraseña actualizada correctamente.",
    emailOrPasswordIncorrect: "Correo electrónico o contraseña incorrectos",
    emailAlreadyRegistered:
        "Es posible que ya tengas una cuenta con este correo electrónico. Inicia sesión o restablece tu contraseña.",
    phoneNumberConfirmed: "Número de teléfono confirmado",
    errorConfirmingPhoneNumber: "Error al confirmar el número de teléfono",
    profileUpdatedSuccess: "Perfil actualizado correctamente",
    professionalDetailsSaved: "Datos profesionales guardados.",
    failedUpdateProfessionalDetails: "No se han podido actualizar los datos profesionales",
    templateCreatedSuccess: "Modelo creado correctamente.",
    templatesCreatedSuccess: (count) =>
        count === 1 ? "Modelo creado correctamente." : `${count} modelos creados correctamente.`,
    failedCreateTemplate: "No se ha podido crear el modelo",
    templateUpdatedSuccess: "Modelo actualizado correctamente",
    failedUpdateTemplate: "No se ha podido actualizar el modelo",
    templateDeletedSuccess: "Modelo eliminado correctamente",
    failedDeleteTemplate: "No se ha podido eliminar el modelo",
    templateDuplicatedSuccess: "Modelo duplicado correctamente",
    failedDuplicateTemplate: "No se ha podido duplicar el modelo",
    templateSharedSuccess: "Modelo compartido correctamente",
    errorSharingTemplate: (message) => `Error al compartir el modelo: ${message}`,
    analyticsViewSharedSuccess: "Vista compartida correctamente",
    errorSharingAnalyticsView: (message) => `Error al compartir la vista: ${message}`,
    analyticsViewUnsharedSuccess: "Vista compartida retirada",
    errorUnsharingAnalyticsView: (message) => `Error al retirar la vista compartida: ${message}`,
    trackerSaved: "Seguimiento guardado",
    entryUpdatedSuccess: "Registro actualizado correctamente",
    entrySaved: "Registro guardado",
    entryDeleted: "Registro eliminado",
    entryTimingUpdated: "Plazo del registro actualizado",
    scheduleUpdated: "Calendario actualizado",
    entryRemovedFromSchedule: "Registro retirado del calendario",
    entryAssignedToScheduleStep: "Registro asignado a un paso del calendario",
    stepAlreadyOccupied: "Este paso ya tiene un registro.",
    diaryUpdatedSuccess: "Diario actualizado correctamente",
    diaryInputsAddedSuccess: "Campos del diario añadidos correctamente",
    diaryDiscardedSuccess: "Diario descartado correctamente",
    diaryReinstatedSuccess: "Diario reactivado correctamente",
    diaryDischargedSuccess: "Diario cerrado correctamente",
    diaryEnded: "Diario cerrado",
    labelCreated: "Etiqueta creada",
    labelUpdated: "Etiqueta actualizada",
    labelDeleted: "Etiqueta eliminada",
    labelsUpdated: "Etiquetas actualizadas",
    tableSettingsSaved: "Ajustes de la tabla guardados",
    detailsSaved: "Su información se ha guardado.",
    hospitalNumberRequired: "El número de historia clínica es obligatorio",
    couldNotSaveHospitalNumber: "No se ha podido guardar el número de historia clínica",
    sharedAttributesUpdated: "Atributos compartidos actualizados",
    errorUpdatingSharedAttributes: "Error al actualizar los atributos compartidos",
    sharedAttributesCreated: "Atributos compartidos creados",
    errorCreatingSharedAttributes: "Error al crear los atributos compartidos",
    diaryAccessSaved: "Acceso al diario guardado",
    failedSaveDiaryAccess: "No se ha podido guardar el acceso al diario",
    joinedDateGroupSuccess: "Grupo de fechas unido correctamente",
    failedJoinDateGroup: (message) => `No se ha podido unir al grupo de fechas: ${message}`,
    questionnaireStopped: "Cuestionario detenido",
    errorStoppingQuestionnaire: "Error al detener el cuestionario",
    consentAddedToDiary: "Consentimiento añadido al diario",
    errorAddingConsentToDiary: "No se ha podido añadir el consentimiento",
    eventSaved: "Evento guardado",
    eventUpdated: "Evento actualizado",
    eventDeletedSuccess: "Evento eliminado correctamente",
    eventTrackerLinked: "Evento y seguimiento vinculados",
    errorLinkingEventTracker: (message) => `Error al vincular el evento y el seguimiento. ${message}`,
    surgerySaved: "Cirugía guardada",
    errorCreatingSurgery: "Error al crear la nueva cirugía",
    surgeryOptionUpdated: "Opción de cirugía actualizada",
    errorUpdatingSurgeryOption: "Error al actualizar la opción de cirugía",
    newSurgeryOptionSaved: "Nueva opción de cirugía guardada",
    consultationSaved: "Consulta guardada",
    errorCreatingConsultation: "Error al crear la nueva consulta",
    errorUpdatingConsultation: "Error al actualizar la consulta",
    imagingRequestSaved: "Solicitud de diagnóstico por imagen guardada",
    errorCreatingImagingRequest: "Error al crear la solicitud de diagnóstico por imagen",
    injectionDetailsUpdated: "Información de la inyección actualizada",
    errorUpdatingInjectionDetails: "Error al actualizar la información de la inyección",
    injectionDiaryDefaultSaved: "Valor predeterminado del diario de inyección guardado",
    errorSavingInjectionDiaryDefault: "Error al guardar el valor predeterminado del diario de inyección",
    diaryInjectionAdded: "Inyección añadida al diario",
    errorCreatingDiaryInjection: "Error al crear la inyección del diario",
    injectionContentUpdated: "Contenido de la inyección actualizado",
    failedUpdateInjectionContent: "No se ha podido actualizar el contenido de la inyección",
    injectionContentDeleted: "Contenido de la inyección eliminado",
    failedDeleteInjectionContent: "No se ha podido eliminar el contenido de la inyección",
    publicStatusUpdated: "Estado público actualizado",
    failedUpdatePublicStatus: "No se ha podido actualizar el estado público",
    injectionLocationUpdated: "Localización de la inyección actualizada",
    failedUpdateInjectionLocation: "No se ha podido actualizar la localización de la inyección",
    newInjectionLocationCreated: "Nueva localización de inyección creada",
    failedCreateInjectionLocation: "No se ha podido crear la localización de la inyección",
    newInjectionContentsCreated: "Nuevos contenidos de inyección creados",
    failedCreateInjectionContents: "No se han podido crear los contenidos de inyección",
    failedSaveInjectionDetails: "No se ha podido guardar la información de la inyección",
    diaryShockwaveAdded: "Ondas de choque añadidas al diario",
    errorCreatingDiaryShockwave: "Error al crear las ondas de choque del diario",
    diaryShockwaveSaved: "Ondas de choque del diario guardadas",
    shockwaveDetailsUpdated: "Información de las ondas de choque actualizada",
    errorUpdatingShockwaveDetails: "Error al actualizar la información de las ondas de choque",
    shockwaveDiaryDefaultSaved: "Valor predeterminado del diario de ondas de choque guardado",
    errorSavingShockwaveDiaryDefault: "Error al guardar el valor predeterminado del diario de ondas de choque",
    shockwaveDetailsRemoved: "Información de las ondas de choque eliminada",
    failedSaveShockwaveDetails: "No se ha podido guardar la información de las ondas de choque",
    scheduleUpdatedSuccess: "Calendario actualizado correctamente",
    failedUpdateSchedule: "No se ha podido actualizar el calendario",
    scheduleDraftCreated: "Borrador de calendario creado",
    failedCreateScheduleFromDraft: "No se ha podido crear el calendario a partir del borrador",
    failedUpdatePublishStatus: "No se ha podido actualizar el estado de publicación",
    formUpdated: "Formulario actualizado",
    failedUpdateForm: "No se ha podido actualizar el formulario",
    formDraftCreated: "Borrador de formulario creado",
    failedCreateFormFromDraft: "No se ha podido crear el formulario a partir del borrador",
    pageSaved: "Página guardada",
    failedSavePage: "No se ha podido guardar la página",
    pageDeleted: "Página eliminada",
    failedDeletePage: "No se ha podido eliminar la página",
    questionSaved: "Pregunta guardada",
    failedSaveQuestion: "No se ha podido guardar la pregunta",
    questionDeleted: "Pregunta eliminada",
    failedDeleteQuestion: "No se ha podido eliminar la pregunta",
    patientAddedSuccess: "Paciente añadido correctamente.",
    emailWordsUpdatedSuccess: "Textos de los correos actualizados correctamente",
    failedUpdateEmailWords: "No se han podido actualizar los textos de los correos",
    emailSentSuccess: "Correo enviado correctamente",
    diaryAlreadyRead: "Diario ya leído",
    noLastReadAction: "No se ha encontrado ninguna última acción de lectura",
    actionComplete: (actionName) => `${actionName} completado`,
    footLogCreatedSuccess: "Diario del pie creado correctamente",
    imageUploadedSuccess: "Imagen enviada correctamente",
    imageLabelCreatedSuccess: "Etiqueta de la imagen creada correctamente",
    qipPermissionsUpdated: "Permisos QIP actualizados correctamente",
    qipPermissionsUpdateFailed: "No se han podido actualizar los permisos QIP",
    riskAssessmentUpdateFailed: "No se ha podido actualizar la evaluación del riesgo",
    footCommentSubmitted: (comment) => `Ha enviado el siguiente comentario:\n${comment}`,
    qrCodeNotReady: "El código QR aún no está listo",
    qrCodeCopiedToClipboard: "Código QR copiado al portapapeles",
    couldNotCopyQrImage:
        "No se ha podido copiar la imagen del código QR. Pruebe en su lugar con una captura de pantalla.",
    inviteSent: "Invitación enviada",
    organisationRoleAddedSuccess: "Rol de organización añadido correctamente",
    errorAddingOrganisationRole: (message) => `Error al añadir el rol de organización: ${message}`,
    organisationRoleUpdatedSuccess: "Rol de organización actualizado correctamente",
    errorUpdatingOrganisationRole: (message) => `Error al actualizar el rol de organización: ${message}`,
    organisationRoleDeletedSuccess: "Rol de organización eliminado correctamente",
    errorDeletingOrganisationRole: (message) => `Error al eliminar el rol de organización: ${message}`,
    secretaryAddedToOrganisation: "Asignación de secretario añadida",
    errorAddingSecretaryToOrganisation: (message) => `Error al añadir la asignación de secretario: ${message}`,
    defaultSecretarySet: "Persona de contacto predeterminada actualizada",
    errorSettingDefaultSecretary: (message) => `Error al establecer la persona de contacto predeterminada: ${message}`,
    defaultSecretaryCleared: "Persona de contacto predeterminada retirada",
    errorClearingDefaultSecretary: (message) => `Error al retirar la persona de contacto predeterminada: ${message}`,
    secretaryRemovedFromOrganisation: "Asignación de secretario retirada",
    errorRemovingSecretaryFromOrganisation: (message) => `Error al retirar la asignación de secretario: ${message}`,
    newOrganisationSaved: "Nueva organización guardada",
    organizationCreatedSuccess: "Organización creada correctamente.",
    audiencesUpdatedSuccess: "Públicos actualizados correctamente",
    errorUpdatingAudiences: "Error al actualizar los públicos",
    labelAccessUpdated: "Acceso por etiqueta actualizado",
    accessUpdated: "Acceso actualizado",
    photoUpdatedSuccess: "Foto actualizada correctamente",
    failedUpdatePhoto: "No se ha podido actualizar la foto",
    photoDeletedSuccess: "Foto eliminada correctamente",
    failedDeletePhoto: "No se ha podido eliminar la foto",
    logoUpdatedSuccess: "Logotipo actualizado correctamente",
    failedUpdateLogo: "No se ha podido actualizar el logotipo",
    logoDeletedSuccess: "Logotipo eliminado correctamente",
    failedDeleteLogo: "No se ha podido eliminar el logotipo",
    smsDisabledInKnock: "SMS desactivados en Knock",
    failedUpdateKnockPreferences: "No se han podido actualizar las preferencias de Knock",
    magicLinkGenerated: "Enlace mágico generado",
    errorImpersonatingUser: "Error al suplantar al usuario",
    fieldUpdatedSuccess: (field) => `${field} se ha actualizado correctamente.`,
    lockUnlockReasonRequired: (action) =>
        `El motivo ${action === "lock" ? "de validación" : "de desbloqueo"} es obligatorio`,
    lockUnlockSuccess: (action, count) => `${count} diarios ${action === "lock" ? "bloqueados" : "desbloqueados"}`,
    errorResolvedSuccess: "Error resuelto correctamente",
    failedResolveError: (message) => `No se ha podido resolver el error: ${message}`,
    healthCheckCompleted: (message) => `Control de integridad completado: ${message}`,
    healthCheckFailed: (message) => `Control de integridad no superado: ${message}`,
    expectedCountUpdatedSuccess: "Número previsto actualizado correctamente",
    failedUpdateExpectedCount: (message) => `No se ha podido actualizar el número previsto: ${message}`,
    fixedRecords: (fixed, failed) => `${fixed} registros corregidos${failed ? `, ${failed} fallidos` : ""}`,
    failedFixSharedAttributes: (message) => `No se han podido corregir los atributos compartidos: ${message}`,
    failedAssignRole: (message) => `No se ha podido asignar el rol: ${message}`,
    failedLoadMessages: "No se han podido cargar los mensajes",
    loggedInSuccess: "Acceso correcto",
    unknownLoginError: "Error de acceso desconocido",
    userDeleted: "Usuario eliminado",
    passwordSetSuccess: "Contraseña establecida correctamente.",
    emailVerificationSent: "Correo de verificación enviado",
    verificationCodeSent: "Código de verificación enviado",
    verificationCodeSentEmail: "Código de verificación enviado a su dirección de correo electrónico",
    failedSendVerificationCode: "No se ha podido enviar el código de verificación",
    emailVerificationFailed: "No se ha podido verificar el correo electrónico",
    emailVerified: "Correo electrónico verificado",
    emailVerifiedShort: "Correo electrónico verificado.",
    invalidVerificationCode: "Código de verificación no válido",
    emailSetSuccess: "Dirección de correo electrónico establecida correctamente",
    emailSavedToProfileToast: "Dirección de correo electrónico guardada en su perfil",
    emailUpdatedSuccessToast: "Dirección de correo electrónico actualizada correctamente",
    superUserStatusUpdated: "Estado de superusuario actualizado",
    userInvited: "Usuario invitado",
    profileAttributeLocked: "El atributo del perfil está bloqueado",
    addressAlreadyInUse: "Esta dirección ya está en uso.",
    mustBeSignedIn: "Debe haber iniciado sesión.",
    contactPersonRequired: "La persona de contacto es obligatoria.",
    somethingWentWrong: "Se ha producido un error. Vuelva a intentarlo.",
    resultsSentToEmail: "Resultados enviados a su dirección de correo electrónico.",
    resultsEmailSendFailed:
        "Sus resultados están listos, pero no se ha podido enviar el correo. Vuelva a intentarlo más tarde.",
    fixHighlightedFieldsBeforeInvite: "Corrija los campos resaltados antes de enviar la invitación.",
    pdfDownloaded: "PDF descargado",
    pdfDownloadFailed: "No se ha podido descargar el PDF",
    pdfGenerationFailed: "No se ha podido generar el PDF",
    questionnaireResumed: "Cuestionario reanudado",
    errorResumingQuestionnaire: "Error al reanudar el cuestionario",
    trackerDeletedSuccess: "Seguimiento eliminado correctamente",
    diaryCreatedSuccess: "Diario creado correctamente",
    diaryDeletedSuccess: "Diario eliminado correctamente",
    templateSavedSuccess: "Modelo guardado correctamente",
    failedSaveTemplate: "No se ha podido guardar el modelo",
    diaryAccessRemoved: "Acceso al diario retirado",
    failedRemoveDiaryAccess: "No se ha podido retirar el acceso al diario",
    entryRemindersTriggered: "Recordatorios de registro activados para el seguimiento",
    correctionSaved: "Corrección guardada",
    correctionReasonRequired: "El motivo de la corrección es obligatorio",
    errorAddingPatient: "Error al añadir al paciente, actualice la página y vuelva a intentarlo.",
    invalidDate: "Fecha no válida",
    failedCreateDiary: (message) => `No se ha podido crear el diario: ${message}`,
    failedUpdateEntry: (message) => `No se ha podido actualizar el registro: ${message}`,
    failedDeleteSchedule: (message) => `No se ha podido eliminar el calendario: ${message}`,
    failedCopySchedule: (message) => `No se ha podido copiar el calendario: ${message}`,
    errorAddingUserToOrganisation: (message) => `Error al añadir al usuario a la organización: ${message}`,
    emailRequiredRefresh:
        "Necesitamos su dirección de correo electrónico para continuar. Actualice la página y envíe de nuevo el formulario.",
    templateStillLoading: "El modelo aún se está cargando. Vuelva a intentarlo dentro de un momento.",
    phoneUpdatedSuccess: "Número de teléfono actualizado correctamente",
    failedUpdatePhone: "No se ha podido actualizar el número de teléfono. Vuelva a intentarlo.",
    completeRequiredFields: (fieldsList) => `Complete los siguientes campos obligatorios:\n${fieldsList}`,
    missingEntry: "Falta un registro",
    formSubmissionError: (message) => `Error al enviar el formulario: ${message}`,
    organisationDeleted: "Organización eliminada",
    noRowsToExport: "No hay ninguna fila que exportar en esta página",
    exportedChangeEventsFromPage: (count) => `${count} eventos de cambio de esta página exportados`,
    noChangeEventsMatchFilters: "Ningún evento de cambio coincide con estos filtros",
    exportedChangeEvents: (count) => `${count} eventos de cambio exportados`,
    mustSignInToExportSnapshot: "Debe haber iniciado sesión para exportar una instantánea",
    noDiariesToExport: "No hay ningún diario que exportar - modifique primero la búsqueda o los filtros",
    chooseSnapshotDateTime: "Elija una fecha y una hora de referencia para la instantánea",
    snapshotExported: (count, dateTime) =>
        count === 1
            ? `Instantánea exportada para 1 diario con fecha del ${dateTime} UTC`
            : `Instantánea exportada para ${count} diarios con fecha del ${dateTime} UTC`,
    snapshotExportFailed: "No se ha podido exportar la instantánea",
    exportFailed: "No se ha podido exportar",
    exportedChangeEventsTruncated: (exported, total) =>
        `Exportación de los primeros ${exported} eventos de cambio de ${total} coincidentes (límite de 10.000 filas)`,
    printing: "Impresión",
    failedGeneratePrintUrl: "No se ha podido generar la URL de impresión",
    reportPrintQueued:
        "Informe puesto en cola. Se generará en el servidor en breve - vuelva a intentar imprimir dentro de unos minutos.",
    reportPrintRendering: "Generando su informe...",
    reportPrintRefreshing: "Diario actualizado - generando un nuevo informe...",
    reportPrintPreparing: "Preparando su informe...",
    reportPrintTimeout:
        "La generación del informe está tardando más de lo previsto. Vuelva a intentar imprimir dentro de unos minutos.",
    unknownError: "Error desconocido",
    failedCreateOrganisation: "No se ha podido crear la organización",
    correctionFailed: "No se ha podido corregir",
    couldNotSaveProcedureDate: "No se ha podido guardar la fecha de su intervención",
    couldNotSave: "No se ha podido guardar",
    invalidFieldSelection:
        "Uno o más campos tienen una selección no válida - compruebe el formulario y vuelva a intentarlo.",
    completeAllRequiredFieldsBeforeSaving: "Complete todos los campos obligatorios antes de guardar.",
    detailsAlreadySaved: "Esta información ya se ha guardado.",
    unableToSaveInjectionDetails:
        "No se ha podido guardar la información de la inyección. Compruebe sus registros y vuelva a intentarlo.",
    unableToSaveShockwaveDetails:
        "No se ha podido guardar la información de las ondas de choque. Compruebe sus registros y vuelva a intentarlo.",
    invitationLinkExpired:
        "Este enlace de invitación ha caducado. Indique su dirección de correo electrónico para obtener un nuevo código.",
    invitationLinkInvalid:
        "Este enlace no es válido o ha caducado. Indique su dirección de correo electrónico para obtener un nuevo código.",
    confirmAccountCouldNotTextTryEmail:
        "No se ha podido enviar un SMS a este número. Pruebe con la dirección de correo electrónico de su invitación, si tiene una.",
    confirmAccountNoAccountForDetails:
        "No hemos encontrado ninguna cuenta que coincida con estos datos. Compruébelos o diríjase al equipo que le invitó si necesita ayuda.",
    smsVerificationUnavailableForNumber:
        "La verificación por SMS aún no está disponible para este número. Use la dirección de correo electrónico de su invitación, o diríjase al equipo que le invitó.",
    smsVerificationTextFailedSignup:
        "No se ha podido enviar un SMS de verificación a este número. Si tiene una cuenta, pruebe a acceder con su dirección de correo electrónico, o pida ayuda al equipo que le invitó.",
    smsSignInNotEnabledForProject:
        "El acceso por SMS no está activado para este proyecto. El equipo que le invitó o la asistencia pueden ayudarle.",
    smsCouldNotSendCheckNumber:
        "No se ha podido enviar un SMS a este número. Compruebe el número, pruebe el acceso por correo electrónico, o diríjase al equipo que le invitó.",
    smsLoginTextFailedOtpDisabled:
        "Hemos encontrado su cuenta, pero no se ha podido enviar un SMS de acceso. Acceda con su correo electrónico y su contraseña, o diríjase al equipo que le invitó si necesita ayuda.",
    smsLoginTextFailedAccountFound:
        "Hemos encontrado su cuenta, pero no se ha podido enviar un SMS de acceso a este número. Acceda con su correo electrónico, o diríjase al equipo que le invitó si necesita ayuda con los SMS.",
    clinicianUpdateFailedDescription: "No se ha podido actualizar el clínico. Vuelva a intentarlo.",
    lockUnlockPartialFailure: (action, succeeded, failed, failedNames, firstError) =>
        `${succeeded} ${action === "lock" ? "bloqueados" : "desbloqueados"}, ${failed} fallidos: ${failedNames} (${firstError})`,
    rolesAssignedToUsers: (role, assigned, failed) =>
        `Rol ${role} asignado a ${assigned} usuarios${failed ? `, ${failed} fallidos` : ""}`,
    pdfDownloadFailedDescription: "No se ha podido descargar el PDF generado",
    pdfGenerationFailedDescription: "No se ha podido generar el PDF",
    pdfDownloadSuccessDescription: "Su PDF se ha descargado correctamente.",
};
